import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { SwapHoriz as MigrationIcon, Visibility as ViewIcon } from '@mui/icons-material';
import { useMigration } from '../../context/MigrationContext';
import MigrationCodeContent from './MigrationCodeContent';

/**
 * Tarjeta fija con el código de migración (Mi Billetera y Ajustes).
 * "Ver de nuevo" reabre el modal. Sin código no renderiza nada.
 */
const MigrationCodeCard = ({ sx = {} }) => {
  const { code, openModal } = useMigration();

  if (!code) return null;

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3, borderLeft: '6px solid #00577A', mb: 3, ...sx }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            flexWrap: 'wrap',
            mb: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MigrationIcon sx={{ color: '#00577A' }} />
            <Typography variant="h6" sx={{ color: '#002642', fontWeight: 700 }}>
              Tu código para pasar a ActionEV
            </Typography>
          </Box>
          <Button size="small" startIcon={<ViewIcon />} onClick={openModal}>
            Ver de nuevo
          </Button>
        </Box>
        <MigrationCodeContent code={code} compact />
      </CardContent>
    </Card>
  );
};

export default MigrationCodeCard;
